import { Component } from '@angular/core';
import { LoaderService } from './services/loader.service';
import { CommonService } from './services/common/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  globalMessageData: any; // To pass data to global messages popup
  globalMessagePopupVisibility: boolean = false; // to show or hide global messages popup
  
  loaderVisibility: boolean;
  constructor(private loader: LoaderService, private commonService: CommonService) {
    this.loader.loaderVisibility.subscribe((visibility)=> {
      this.loaderVisibility = visibility;
    });

    // Subscribed to global message to get message data on production
    this.commonService.getGlobalMessageObservable().subscribe((messageData) => {
      this.globalMessageData = messageData;
    });

    // Subscribed to global message popup visibility to toggle its visibility
    this.commonService.getGlobalMessagePopupVisibility().subscribe((visibility) => {
      this.globalMessagePopupVisibility = visibility;
    })
  }
}
